import api from '@/libs/axios'


export default {
  async create(payload) {
    const response = await api.post('/admin/social-topics', payload)
    return response.data.data.new_document || null
  },
  async update(payload) {
    let response = await api.put('/admin/social-topics', payload)
    return response
  },
  async delete(payload) {
    const response = await api.delete('/admin/social-topics', {
      data: payload,
    })
    return response
  },
  async getList(params) {
    let response = await api.get('/admin/social-topics', {
      params,
    })
    return response.data.data
  },
  async get(params) {
    let response = await api.get('/admin/social-topics/detail', {
      params,
    })
    return response.data.data.document || null
  },
}
